import React from 'react'
import './EnviosServicios.scss'

import atencionImg from '../../images/site/atencion.jpg'
import enviosImg from '../../images/site/envios.jpg'
import retiroImg from '../../images/site/retiro.jpg'

const services = [
	{
		id: 'atencion',
		title: 'Horario de atención',
		description: (
			<>
				Lunes a Viernes de 8 a 17hs,<br />sábados de 8.30 a 12.30hs
			</>
		),
		image: atencionImg,
		alt: 'Icono de atencion al cliente'
	},
	{
		id: 'retiro',
		title: 'Entrega express',
		description: 'Hacenos tu pedido por WhatsApp y retíralo al instante por mostrador.',
		image: retiroImg,
		alt: 'Icono de caja de retiro'
	},
	{
		id: 'envios',
		title: 'Envío simple',
		description: 'Dejanos tu pedido y recibilo en 24 hs.',
		image: enviosImg,
		alt: 'Icono de envio en camion'
	}
]

const EnviosServicios = () => {
	return (
		<section className="envios-servicios mt-3">
			<div className="container">
				<div className="envios-servicios__grid">
					{services.map((service) => (
						<article className="envios-servicios__item" key={service.id}>
							<div className="envios-servicios__icon">
								<img src={service.image} alt={service.alt} loading="lazy" />
							</div>
							<h3>{service.title}</h3>
							<p>{service.description}</p>
						</article>
					))}
				</div>
			</div>
		</section>
	)
}

export default EnviosServicios
